import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import ButtonBase from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { ChevronRightBold } from '@sorare/core/src/atoms/icons/ChevronRightBold';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { useEarlyAccessRefinement } from '@sorare/core/src/hooks/search/useEarlyAccess';
import { glossary } from '@sorare/core/src/lib/glossary';

import EarlyAccessDialog from 'components/market/EarlyAccessDialog';

const Wrapper = styled(ButtonBase)`
  background-color: var(--c-neutral-300);
  padding: var(--intermediate-unit);
  border-radius: var(--unit);
  justify-content: center;
  text-align: center;
  &:hover {
    background-color: var(--c-neutral-200);
  }
`;

const Underline = styled(BodyM)`
  text-decoration: underline;
`;

const Coloured = styled(BodyM)`
  background: linear-gradient(
    92deg,
    #fff 0%,
    #eabfe2 28.88%,
    #fff 48.67%,
    #bedecb 64.58%,
    #fff 100%
  );

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const EarlyAccessInfos = () => {
  const { enabledEarlyAccess } = useEarlyAccessRefinement();

  const [open, setOpen] = useState(false);
  if (!enabledEarlyAccess) {
    return null;
  }
  return (
    <>
      <Wrapper onClick={() => setOpen(true)}>
        <Horizontal gap={1} center>
          <FontAwesomeIcon icon={faInfoCircle} />
          <Coloured bold>
            <FormattedMessage
              id="search.earlyAccess.infos"
              defaultMessage="Early Access are playable now"
            />
          </Coloured>
          <Underline>
            <FormattedMessage {...glossary.more} />
          </Underline>
          <ChevronRightBold />
        </Horizontal>
      </Wrapper>
      <EarlyAccessDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
